import { useMutation, useQuery } from '@tanstack/react-query'
import { NotificationService } from '@/modules/utilities/notification/services/NotificationService.ts'
import useInvalidateQuery from '@/core/hooks/useInvalidateQuery.ts'

const pollingInterval = 300000 //in miliseconds

const useNotification = () => {
  const { invalidate } = useInvalidateQuery()

  const { data, isFetching } = useQuery({
    queryKey: ['getNotifications'],
    queryFn: () => NotificationService.getLast(),
    refetchOnWindowFocus: false,
    refetchInterval: pollingInterval
  })
  const { mutate: handlerMarkAllAsRead, isPending } = useMutation({
    mutationKey: ['markAsReadAll'],
    mutationFn: () => NotificationService.readAll(),
    onSuccess: () => {
      void invalidate({ queryKey: ['getNotifications'] })
    }
  })

  return {
    notifications: data ? data : { last: [], unread: 0 },
    isFetching,
    handlerMarkAllAsRead,
    isPending
  }
}

export default useNotification
